import moment from 'moment'
import React from 'react'
import { Link } from 'react-router-dom'
import { Delete, Eye, Pencil } from '../../common/Icons'
import AddPrompt from '../../common/popups/AddPrompt'
import { deleteRequest, postRequest } from '../../apis/functions'
import APIS from '../../apis/routes'
import { toaster } from '../../apis/commonFunctions'

const MyRow = ({ element, index, onFetch }) => {
    const updatePrompt = async (obj) => {
        try {
            // setLoading(true);
            const result = await postRequest(APIS.UPDATE_PROMPT, obj);
            // setLoading(false);
            if (!result.data.status) {
                toaster(result.data.message, false)
            } else {
                toaster(result.data.message, true);
                onFetch()
                // setTotal(result.data.total_count)

            }
        } catch (err) {
            toaster(err.message, false);
        }
    }

    const deletePrompt = async (id) => {
        try {
            // setLoading(true);
            const result = await deleteRequest(APIS.DELETE_PROMPT + "/" + id);
            // setLoading(false);
            if (!result.data.status) {
                toaster(result.data.message, false)
            } else {
                toaster(result.data.message, true);
                // setTotal(result.data.total_count)
                onFetch()

            }
        } catch (err) {
            toaster(err.message, false);
        }
    }

    return (
        <>
            <tr key={element._id}>
                <td>{index + 1}</td>
                <td style={{ textTransform: "inherit" }}>{element.prompt}</td>
                <td style={{ textTransform: "unset" }}>{element.is_premium ? "Yes" : "No"}</td>
                <td style={{ textTransform: "unset" }}>{moment(element.createdAt).format("DD MMM YYYY")}</td>
                <td>
                    <div className="actions">
                        <button className='view p-2' data-bs-toggle="modal" data-bs-target={"#modal" + element._id}>
                            {/* <Link className='view' to={'/user-management/' + element._id}> */}
                            <Pencil />
                            {/* </Link> */}
                        </button>
                        {/* <button className='view p-2'>
                                                    <Link className='view' to={'/user-emi-management/' + element._id}>
                                                        <Calculator />
                                                    </Link>
                                                </button> */}
                        {/* <button className='block' onClick={() => { blockUnblockUser(element._id) }} style={{ color: (element.admin_blocked ? "#0F993E" : "#ff4c27") }}>
                                                    <Block />
                                                </button> */}
                        <button className='delete' onClick={() => deletePrompt(element._id)}
                        // data-bs-toggle="modal" data-bs-target="#decline_modal"
                        >
                            <Delete />
                        </button>
                    </div>
                </td>
            </tr>
            <AddPrompt onYes={(obj) => {
                updatePrompt({
                    _id: element._id,
                    ...obj
                });
            }} question_type={element.question_type} id={element._id} message={"Edit Prompt"} is_premium={element.is_premium} prompt={element.prompt} />
        </>
    )
}

export default MyRow